import { TherapeuticClass } from "../pbm/Benefit/therapeutic-class";
import { IAutoCompleteItem } from "./iauto-complete-item";

export class TherapeuticClassProductAutoCompleteItem implements IAutoCompleteItem {
  constructor(private therapeuticClass: TherapeuticClass) {}

  getKey(): string {
    return this.getTherapeuticClassKey();
  }

  getDisplayValue(): string {
    return this.therapeuticClass.getDescription();
  }

  getTherapeuticClassKey(): string {
    return this.therapeuticClass.getTherapeuticClassKey();
  }

  getDescription(): string {
    return this.therapeuticClass.getDescription();
  }

  getCode(): string {
    return this.therapeuticClass.getCode();
  }
}
